import {FC} from 'react';
import {getMyTaxAccessErrorDescription, MY_TAX_ACCESS_ERROR_TITLE, RegistrationWorkStatus} from '../../model';
import {MyTaxQrBlock} from '../components/MyTaxQrBlock/MyTaxQrBlock';
import {StepLayout} from 'features/registration';

type Props = {
	workStatus: RegistrationWorkStatus | null;
};

export const MyTaxAccessErrorStep: FC<Props> = ({workStatus}) => {
	return (
		<StepLayout variant="fill">
			<StepLayout.Intro title={MY_TAX_ACCESS_ERROR_TITLE} subtitle={getMyTaxAccessErrorDescription(workStatus)} />

			<StepLayout.Content>
				<MyTaxQrBlock variant="error" />
			</StepLayout.Content>
		</StepLayout>
	);
};
